import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API_BASE = `${BACKEND_URL}/api`;

const auth = () => ({ Authorization: `Bearer ${localStorage.getItem('token')}` });

export const moratoriumsAPI = {
  list: (params = {}) =>
    axios.get(`${API_BASE}/moratoriums`, { headers: auth(), params }),
  get: (id) => axios.get(`${API_BASE}/moratoriums/${id}`, { headers: auth() }),
  create: (data) => axios.post(`${API_BASE}/moratoriums`, data, { headers: auth() }),
  update: (id, data) => axios.put(`${API_BASE}/moratoriums/${id}`, data, { headers: auth() }),
  remove: (id) => axios.delete(`${API_BASE}/moratoriums/${id}`, { headers: auth() }),
  finalize: (id) => axios.post(`${API_BASE}/moratoriums/${id}/finalize`, {}, { headers: auth() }),
  markInstallmentPaid: (id, index, paymentId = null) =>
    axios.post(
      `${API_BASE}/moratoriums/${id}/mark-installment-paid`,
      { index, payment_id: paymentId },
      { headers: auth() }
    ),
  downloadPdf: (id) =>
    axios.get(`${API_BASE}/moratoriums/${id}/pdf`, {
      headers: auth(),
      responseType: 'blob',
    }),
};

export default moratoriumsAPI;
